<div class="maintenance" role="alert">
  <div class="maintenance__card">
    <i class="fas fa-screwdriver-wrench maintenance__icon" aria-hidden="true"></i>

    <h1 class="maintenance__title">{{ translate.instant('MAINTENANCE.TITLE') }}</h1>

    <p class="maintenance__message">
      {{ message || translate.instant('MAINTENANCE.MESSAGE') }}
    </p>

    <!-- Pas d'échéance annoncée ⇒ pas de ligne. Un « jusqu'à : — » ne rassure
         personne et une échéance inventée serait pire que pas d'échéance. -->
    <p class="maintenance__until" *ngIf="until">
      {{ translate.instant('MAINTENANCE.UNTIL') }} {{ until | date: 'short' }}
    </p>

    <button type="button" class="maintenance__action" (click)="reload()">
      {{ translate.instant('MAINTENANCE.RETRY') }}
    </button>
  </div>
</div>
